import { Component, Input } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';

import { NgIf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { AlertDescriptor } from './alert';

@Component({
  imports: [MatDialogModule, TranslateModule, MatButtonModule, NgIf],
  template: `
    <h2 mat-dialog-title>{{ alert.titleText | translate }}</h2>
    <mat-dialog-content class="alert-container">
      <p [innerHTML]="alert.subtitleText | translate"></p>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button *ngIf="alert.cancelButtonText" mat-button color="primary" matDialogClose>
        {{ alert.cancelButtonText | translate }}
      </button>
      <button mat-raised-button color="primary" (click)="dialogRef.close('yes')">
        {{ alert.confirmButtonText | translate }}
      </button>
    </mat-dialog-actions>
  `,
})
export class VaAlertComponent {
  @Input() alert: AlertDescriptor;

  constructor(public dialogRef: MatDialogRef<VaAlertComponent>) {}
}
